namespace SP {

    export const ShelflabelTemplates: { [id: string]: ShelflabelTempate } = {
        "1": {
            id: 1,
            name: "Horizontal [SECTION+UNIT][ROW][PLACE][QR]"
        },
        "2": {
            id: 2,
            name: "Horizontal [QR][SECTION+UNIT][ROW][PLACE]"
        },
        "3": {
            id: 3,
            name: "Horizontal [QR][SECTION][UNIT][ROW]"
        },
        "4": {
            id: 4,
            name: "Horizontal [SECTION][UNIT][ROW][QR]"
        },
        "5": {
            id: 5,
            name: "Vertical [QR][SECTION+UNIT][ROW][PLACE]"
        },
        "6": {
            id: 6,
            name: "Vertical [SECTION+UNIT][ROW][PLACE][QR]"
        },
        "7": {
            id: 7,
            name: "Horizontal [SECTION][UNIT][ROW][CODE128]"
        },
        "8": {
            id: 8,
            name: "Horizontal [SECTION][UNIT][ROW][PLACE][CODE128]"
        },
        "9": {
            id: 9,
            name: "Horizontal [SECTION-UNIT][ROW][PLACE][QR]"
        },
        "10": {
            id: 10,
            name: "Horizontal [SECTION+UNIT][ROW][QR] (simple)"
        },
        "11": {
            id: 11,
            name: "Horizontal [SECTION][UNIT][PLACE][QR]"
        },
        "12": {
            id: 12,
            name: "Horizontal [SECTION][UNIT][ROW][PLACE][QR]"
        },
        "13": {
            id: 13,
            name: "Horizontal [SECTION][ROW][UNIT][CODE128]"
        }
    }
}